import './Badge.scss';

import * as React from 'react';

import cx from 'classnames';

type BadgeTone =
  | 'ai'
  | 'pro'
  | 'neutral'
  | 'positive'
  | 'beta'
  | 'info'
  | 'promotion'
  | 'muted';

export interface BadgeProps {
  children: React.ReactNode;
  /** @todo Options for setting variant styles */
  tone?: BadgeTone;
  textTransform?: 'uppercase' | 'lowercase' | 'capitalize' | 'normal-case';
  className?: string;
}

const backgroundToneMap = new Map<BadgeTone, string>([
  ['ai', 'bg-cyan-200'],
  ['pro', 'bg-orange-700'],
  ['promotion', 'bg-orange-200'],
  ['beta', 'bg-green-200'],
  ['positive', 'bg-green-700'],
  ['neutral', 'bg-grey-200'],
  ['info', 'bg-amber-300'],
  ['muted', 'bg-grey-100'],
]);

const textColourToneMap = new Map<BadgeTone, string>([
  ['ai', 'text-cyan-700'],
  ['beta', 'text-green-900'],
  ['info', 'text-amber-900'],
  ['neutral', 'text-blue-900'],
  ['promotion', 'text-blue-900'],
  ['muted', 'text-grey-900'],
]);

export function Badge({
  children,
  tone = 'pro',
  className,
  textTransform = 'uppercase',
  ...props
}: BadgeProps) {
  const badgeClass = cx(
    'rounded-1 font-600 text-xs leading-6  px-1',
    {
      ['flex justify-center items-center ']: true,
    },
    textTransform,
    textColourToneMap.get(tone) ?? 'text-white',
    backgroundToneMap.get(tone),
    className
  );

  return (
    <div className={badgeClass} {...props}>
      {children}
    </div>
  );
}
